import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const TextBox = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M17.25 12H6.75m10.5-2.625H6.75m6.75 5.25H6.75M3.9 18h16.2c.497 0 .9-.47.9-1.05v-9.9c0-.58-.403-1.05-.9-1.05H3.9c-.497 0-.9.47-.9 1.05v9.9c0 .58.403 1.05.9 1.05Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(TextBox) as SvgIcon;
export { ForwardRef as ReactComponent };
